// removed by extract-text-webpack-plugin
module.exports = {"wrap":"rec_a_3MSh9Q4","wrap_content":"rec_a_3y9DIyK","wrap_content_item":"rec_a_hqcohKe","hover_img":"rec_a_2yTXTRE"};


//////////////////
// WEBPACK FOOTER
// ./src/component/rec/rec_a.css
// module id = 842
// module chunks = 0